import { render, staticRenderFns } from "./ProfessionalMore.vue?vue&type=template&id=08380526&scoped=true"
import script from "./ProfessionalMore.vue?vue&type=script&lang=js"
export * from "./ProfessionalMore.vue?vue&type=script&lang=js"
import style0 from "./ProfessionalMore.vue?vue&type=style&index=0&id=08380526&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08380526",
  null
  
)

export default component.exports